import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-withdraw",
  "use": "icon-withdraw-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-withdraw\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.4 138.5c-206.5 0-373.8 167.4-373.8 373.8S305 886.2 511.4 886.2s373.8-167.4 373.8-373.8-167.3-373.9-373.8-373.9z m159.2 385.2L522.8 671.5c-6.3 6.3-16.4 6.3-22.7 0L352.2 523.7c-6.3-6.3-6.3-16.4 0-22.7L500 353.2c6.3-6.3 16.4-6.3 22.7 0L670.6 501c6.3 6.3 6.3 16.4 0 22.7z\" p-id=\"8215\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/withdraw.svg
// module id = kGe1
// module chunks = 7